// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.BookingList-containerWith-Blkdc {
    width: 100%;
    max-width: 1260px !important;
    margin: 0 auto;
}

.BookingList-container-rhra5 {
    max-width: 100%;
}

/* Text - Start */

.BookingList-subText-PtKKB {
    color: var(--secondary-foreground);
    font-size: 14px;
}

/* Text - End */

/* Header */

.BookingList-navigationLink-fGa5B a {
    padding-right: 20px !important;
    padding-left: 20px !important;
    color: var(--primary-foreground) !important;
    font-size: 18px;
    border-bottom: 2px solid transparent;
}

.BookingList-navigationLink-fGa5B a:hover,
.BookingList-navigationLink-fGa5B a:focus,
.BookingList-navigationLink-fGa5B a:active {
    border-bottom: 2px solid var(--primary-foreground);
}

/* Header */

/* commonCss */

.BookingList-noPadding-YWTNG {
    padding: 0;
}

.BookingList-heading-vURjB {
    padding: 30px 0px 24px 0px;
    font-weight: 700;
    font-size: 24px;
    color: var(--primary-foreground);
}

.BookingList-widthInner-HQelW {
    margin: 0px auto 0px auto;
    border-radius: 4px;
    padding: 0px;
    margin: 0px 15px 30px;
}

.BookingList-noMargin-s9bug {
    margin: 0;
}

.BookingList-formControlInputTable-M64IM {
    border: none;
    width: 100px;
    height: auto;
}

.BookingList-backBtn-YJB1b {
    margin-left: 15px;
    display: inline-block;
}

.BookingList-backBtn-YJB1b:active,
.BookingList-backBtn-YJB1b:hover,
.BookingList-backBtn-YJB1b:focus {
    color: var(--primary-bg);
    text-decoration: none !important;
}

.BookingList-textAlignRight-AhEbB {
    text-align: right;
}

.BookingList-displayInlineBlock-DqUyj {
    display: inline-block;
}

.BookingList-displayBlock-SRtva {
    display: block;
}

.BookingList-countryCode-CvUEg {
    width: 15%;
    vertical-align: top;
}

.BookingList-vtrMiddle-DukbH {
    vertical-align: middle;
}

/* commonCss */

.BookingList-editIcon-EqdO6 {
    width: 100%;
    width: 15px;
    vertical-align: middle;
    margin-right: 3px;
}

.BookingList-iconBtn-kZWVS,
.BookingList-iconBtn-kZWVS:hover,
.BookingList-iconBtn-kZWVS:focus {
    padding: 0 !important;
    background: transparent !important;
    color: var(--danger-action-color) !important;
    border: 0 !important;
    white-space: nowrap;
    font-size: 16px !important;
    text-decoration: unset !important;
    cursor: pointer;
}

.BookingList-profileImg-rmMpo {
    width: 100%;
    height: auto;
    margin-bottom: 18px;
}

.BookingList-profileImgSection-kZduv {
    width: 100%;
    margin: 0 auto;
    padding: 30px;
    border-radius: 12px;
    border: 1px solid var(--primary-border);
    background: var(--primary-input-bg);

}

.BookingList-profileImgWidth-n9l1z {
    margin: 0;
    max-width: 100% !important;
}

.BookingList-searchInput-q4ygd {
    width: 100%;
    max-width: 320px;
}

.BookingList-backgroundImg-lP5Yq {
    padding-top: 42%;
    background-repeat: no-repeat;
    background-size: contain;
    margin-bottom: 18px;
    border-radius: 4px;
    background-color: transparent;
    background-position: center;
    margin-top: 6px;
    border: 1px dashed var(--primary-border);
    border-radius: 12px;
}

/*******************Export CSV section start ******************/

.BookingList-exportDisplay-F89am {
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-pack: justify;
        -ms-flex-pack: justify;
            justify-content: space-between;
    -ms-flex-wrap: wrap;
        flex-wrap: wrap;
    -webkit-box-align: center;
        -ms-flex-align: center;
            align-items: center;
    margin-bottom: 18px;
    gap: 18px;
    grid-gap: 18px;
}

.BookingList-exportTextSection-dRXS1 {
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-align: center;
        -ms-flex-align: center;
            align-items: center;
    gap: 12px;
    -ms-flex-wrap: wrap;
        flex-wrap: wrap;
}

.BookingList-exportText-hnsA1 {
    display: inline-block;
    padding-right: 5px;
}

.BookingList-exportTextContainer-UiE3f {
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-align: center;
        -ms-flex-align: center;
            align-items: center;
    color: var(--primary-link-foreground) !important;
    text-decoration: unset !important;
    border-bottom: 1px solid var(--primary-link-foreground);
}

.BookingList-vtrTextBottom-ktaQC {
    vertical-align: text-bottom;
}

.BookingList-exportImg-xwLgF {
    width: 100%;
    max-width: 14px;
    height: 14px;
    -o-object-fit: contain;
       object-fit: contain;
}

/*******************Export CSV section End ******************/

.BookingList-noLink-dqsXJ,
.BookingList-noLink-dqsXJ:hover {
    color: var(--primary-link-foreground) !important;
    cursor: pointer;
}

.BookingList-singleCard-YuN2a {
    width: 500px;
    margin: 0 auto;
}

.BookingList-defaultIcon-YMiJ_ {
    background-size: 50px;
}

.BookingList-assignProviderSearchInput-eKfl_ {
    width: 100%;
    max-width: 324px;
}

.BookingList-searchGroupContainer-XPOBw {
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-align: center;
        -ms-flex-align: center;
            align-items: center;
    gap: 12px;
    -webkit-box-flex: 1;
        -ms-flex-positive: 1;
            flex-grow: 1;
}

@media (max-width: 767px) {
    .BookingList-searchGroupContainer-XPOBw {
        width: 100%;
    }

}

@media (max-width: 1199px) and (min-width: 1024px) {
  .BookingList-widthInner-HQelW {
    width: 100%;
    border-radius: 0;
    margin: 0 auto;
  }

  .BookingList-aboutGrid-wF4VT img {
    position: relative;
    top: -25px !important;
  }

  .BookingList-responsiveView-b2bbu {
    width: 100% !important;
    max-width: 175px !important;
  }

  .BookingList-positionFive-ukd_f {
    top: 28% !important;
  }

  .BookingList-positionTwo-wmOMT {
    top: 28% !important;
  }

  .BookingList-responsiveContentOne-zeMLC {
    top: -50px !important;
  }

  .BookingList-positionFour-s20s2 {
    top: -50px !important;
  }

  .BookingList-totalCss-iUrsa {
    width: 100% !important;
  }


}

@media (max-width: 1024px) {
  .BookingList-navbar-expand-lg-YLUNh .BookingList-navbar-toggler-yWTEo {
    display: block !important;
    position: absolute;
    top: 23px;
    right: 20px;
  }

  .BookingList-profileImgSection-kZduv {
    padding: 18px;
  }
}

@media (max-width: 1023px) and (min-width: 768px) {

  .BookingList-navigationLink-fGa5B a {
    color: var(--primary-foreground) !important;
  }

  .BookingList-widthInner-HQelW {
    width: 100%;
    border-radius: 0;
    margin: 0 auto;
  }

  .BookingList-responsiveContentOne-zeMLC {
    width: 300px !important;
    position: absolute !important;
    top: -42px !important;
    left: -5% !important;
  }

  .BookingList-positionTwo-wmOMT {
    top: 24% !important;
    left: -5% !important;
  }

  .BookingList-positionThree-jSwOW {
    top: 70% !important;
    left: -5% !important;
  }

  .BookingList-positionFour-s20s2 {
    top: -42px !important;
    right: -5% !important;
  }

  .BookingList-positionFive-ukd_f {
    top: 20% !important;
    right: -5% !important;
  }

  .BookingList-positionSix-rJhxH {
    top: 70% !important;
    right: -5% !important;
  }

  .BookingList-responsiveView-b2bbu {
    width: 100% !important;
    max-width: 115px !important;
  }

  .BookingList-aboutGrid-wF4VT img {
    top: -1px !important;
  }

  .BookingList-contentOne-PhREp h1 {
    font-size: 16px !important;
  }

  .BookingList-contentOne-PhREp p {
    font-size: 12px !important;
  }


  .BookingList-totalCss-iUrsa {
    width: 100% !important;
  }

  .BookingList-padding-Nm7bs {
    padding: 0px 0 0 60px !important;
  }

  .BookingList-singleCard-YuN2a {
    width: 100% !important;
  }

  .BookingList-navigationLink-fGa5B a:hover,
  .BookingList-navigationLink-fGa5B a:focus,
  .BookingList-navigationLink-fGa5B a:active {
    border-bottom: 2px solid transparent;
  }
}

@media screen and (max-width: 823px) {
  .BookingList-navbar-collapse-SLBnO.BookingList-show-GjAFS {
    right: 0% !important;
    top: 0 !important;
  }

  .BookingList-navbar-collapse-SLBnO {
    position: fixed !important;
    height: 100vh !important;
    width: 100% !important;
    background: #fff !important;
    right: -100% !important;
    -webkit-transition: 0.5s !important;
    transition: 0.5s !important;
  }
}

@media (max-width: 767px) {
  .BookingList-content-xvG6P {
    float: none;
  }

  .BookingList-mr-auto-j6oEx.BookingList-navbar-nav-Q2nvC {
    padding-bottom: 80px !important;
  }

  .BookingList-navigationLink-fGa5B a {
    color: var(--primary-foreground) !important;
  }

  .BookingList-footer-EnqVT {
    padding: 35px 0 0 15px;
  }

  .BookingList-widthInner-HQelW {
    width: 100%;
    margin: 0px auto 0 auto;
    border-radius: 0;
  }

  .BookingList-responsiveNoPadding-gJPU3 {
    padding: 0px !important;
  }

  .BookingList-contentOne-PhREp {
    position: relative !important;
    text-align: left !important;
    width: auto !important;
    padding: 0px 15px !important;
  }

  .BookingList-aboutContainer-YPi99 {
    padding: 30px 0 30px !important;
  }

  .BookingList-noPosition-QgcX9 {
    left: 0 !important;
    right: 0 !important;
    top: 0 !important;
  }

  .BookingList-mobimleImg-UIfc8 {
    display: none !important;
  }

  .BookingList-totalCss-iUrsa {
    width: 100% !important;
  }

  .BookingList-imgWidth-LnTrq {
    padding: 18px !important;
  }

  .BookingList-searchInput-q4ygd,
  .BookingList-assignProviderSearchInput-eKfl_ {
    max-width: 100% !important;
  }

  .BookingList-exportText-hnsA1 {
    display: inline-block;
  }

  .BookingList-gridSystem-VyPMb {
    grid-template-columns: auto !important;
  }

  .BookingList-padding-Nm7bs {
    padding: 52px 0 0 0 !important;
  }

  .BookingList-heading-vURjB {
    padding: 30px 0 24px !important;
  }

  .BookingList-singleCard-YuN2a {
    width: 100% !important;
  }

  .BookingList-displayGrid-slzKZ {
    grid-template-columns: 100% !important;
    grid-gap: 12px;
  }

  .BookingList-boxInner-SI0Pp {
    padding: 35px 0 !important;
  }

  .BookingList-navigationLink-fGa5B a:hover,
  .BookingList-navigationLink-fGa5B a:focus,
  .BookingList-navigationLink-fGa5B a:active {
    border-bottom: 2px solid transparent;
  }
}

@media (max-width: 480px) and (min-width: 320px) {
  .BookingList-whiteDropdown-KBF3B select {
    width: 120px !important;
  }
}

.BookingList-floatRight-uUUbA {
    float: right;
    margin-left: 11px;
}

.BookingList-vtrTextBottom-ktaQC {
    vertical-align: middle;
}

@media (max-width:1023px) and (min-width:768px) {
    .BookingList-buttonMargin-WJYMJ {
        margin-top: 12px;
    }
}`, "",{"version":3,"sources":["webpack://./src/components/Common.css","webpack://./src/components/responsive-common.css","webpack://./src/components/Booking/BookingList/BookingList.css"],"names":[],"mappings":"AAAA;IACI,WAAW;IACX,4BAA4B;IAC5B,cAAc;AAClB;;AAEA;IACI,eAAe;AACnB;;AAEA,iBAAiB;;AACjB;IACI,kCAAkC;IAClC,eAAe;AACnB;;AAEA,eAAe;;AAEf,WAAW;;AAEX;IACI,8BAA8B;IAC9B,6BAA6B;IAC7B,2CAA2C;IAC3C,eAAe;IACf,oCAAoC;AACxC;;AAEA;;;IAGI,kDAAkD;AACtD;;AAEA,WAAW;;AAEX,cAAc;;AACd;IACI,UAAU;AACd;;AAEA;IACI,0BAA0B;IAC1B,gBAAgB;IAChB,eAAe;IACf,gCAAgC;AACpC;;AAEA;IACI,yBAAyB;IACzB,kBAAkB;IAClB,YAAY;IACZ,qBAAqB;AACzB;;AAEA;IACI,SAAS;AACb;;AAEA;IACI,YAAY;IACZ,YAAY;IACZ,YAAY;AAChB;;AAEA;IACI,iBAAiB;IACjB,qBAAqB;AACzB;;AAEA;;;IAGI,wBAAwB;IACxB,gCAAgC;AACpC;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,UAAU;IACV,mBAAmB;AACvB;;AAEA;IACI,sBAAsB;AAC1B;;AAEA,cAAc;;AAEd;IACI,WAAW;IACX,WAAW;IACX,sBAAsB;IACtB,iBAAiB;AACrB;;AAEA;;;IAGI,qBAAqB;IACrB,kCAAkC;IAClC,4CAA4C;IAC5C,oBAAoB;IACpB,mBAAmB;IACnB,0BAA0B;IAC1B,iCAAiC;IACjC,eAAe;AACnB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,mBAAmB;AACvB;;AAEA;IACI,WAAW;IACX,cAAc;IACd,aAAa;IACb,mBAAmB;IACnB,uCAAuC;IACvC,mCAAmC;;AAEvC;;AAEA;IACI,SAAS;IACT,0BAA0B;AAC9B;;AAEA;IACI,WAAW;IACX,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;IAChB,4BAA4B;IAC5B,wBAAwB;IACxB,mBAAmB;IACnB,kBAAkB;IAClB,6BAA6B;IAC7B,2BAA2B;IAC3B,eAAe;IACf,wCAAwC;IACxC,mBAAmB;AACvB;;AAEA,+DAA+D;;AAC/D;IACI,oBAAa;IAAb,oBAAa;IAAb,aAAa;IACb,yBAA8B;QAA9B,sBAA8B;YAA9B,8BAA8B;IAC9B,mBAAe;QAAf,eAAe;IACf,yBAAmB;QAAnB,sBAAmB;YAAnB,mBAAmB;IACnB,mBAAmB;IACnB,SAAS;IACT,cAAc;AAClB;;AAEA;IACI,oBAAa;IAAb,oBAAa;IAAb,aAAa;IACb,yBAAmB;QAAnB,sBAAmB;YAAnB,mBAAmB;IACnB,SAAS;IACT,mBAAe;QAAf,eAAe;AACnB;;AAEA;IACI,qBAAqB;IACrB,kBAAkB;AACtB;;AAEA;IACI,oBAAa;IAAb,oBAAa;IAAb,aAAa;IACb,yBAAmB;QAAnB,sBAAmB;YAAnB,mBAAmB;IACnB,gDAAgD;IAChD,iCAAiC;IACjC,uDAAuD;AAC3D;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,WAAW;IACX,eAAe;IACf,YAAY;IACZ,sBAAmB;OAAnB,mBAAmB;AACvB;;AAEA,6DAA6D;;AAC7D;;IAEI,gDAAgD;IAChD,eAAe;AACnB;;AAEA;IACI,YAAY;IACZ,cAAc;AAClB;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,WAAW;IACX,gBAAgB;AACpB;;AAEA;IACI,oBAAa;IAAb,oBAAa;IAAb,aAAa;IACb,yBAAmB;QAAnB,sBAAmB;YAAnB,mBAAmB;IACnB,SAAS;IACT,mBAAY;QAAZ,oBAAY;YAAZ,YAAY;AAChB;;AAEA;IACI;QACI,WAAW;IACf;;AAEJ;;AC1OA;EACE;IACE,WAAW;IACX,gBAAgB;IAChB,cAAc;EAChB;;EAEA;IACE,kBAAkB;IAClB,qBAAqB;EACvB;;EAEA;IACE,sBAAsB;IACtB,2BAA2B;EAC7B;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,qBAAqB;EACvB;;EAEA;IACE,qBAAqB;EACvB;;EAEA;IACE,sBAAsB;EACxB;;;AAGF;;AAEA;EACE;IACE,yBAAyB;IACzB,kBAAkB;IAClB,SAAS;IACT,WAAW;EACb;;EAEA;IACE,aAAa;EACf;AACF;;AAEA;;EAEE;IACE,2CAA2C;EAC7C;;EAEA;IACE,WAAW;IACX,gBAAgB;IAChB,cAAc;EAChB;;EAEA;IACE,uBAAuB;IACvB,6BAA6B;IAC7B,qBAAqB;IACrB,oBAAoB;EACtB;;EAEA;IACE,mBAAmB;IACnB,oBAAoB;EACtB;;EAEA;IACE,mBAAmB;IACnB,oBAAoB;EACtB;;EAEA;IACE,qBAAqB;IACrB,qBAAqB;EACvB;;EAEA;IACE,mBAAmB;IACnB,qBAAqB;EACvB;;EAEA;IACE,mBAAmB;IACnB,qBAAqB;EACvB;;EAEA;IACE,sBAAsB;IACtB,2BAA2B;EAC7B;;EAEA;IACE,oBAAoB;EACtB;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,0BAA0B;EAC5B;;;EAGA;IACE,sBAAsB;EACxB;;EAEA;IACE,gCAAgC;EAClC;;EAEA;IACE,sBAAsB;EACxB;;EAEA;;;IAGE,oCAAoC;EACtC;AACF;;AAEA;EACE;IACE,oBAAoB;IACpB,iBAAiB;EACnB;;EAEA;IACE,0BAA0B;IAC1B,wBAAwB;IACxB,sBAAsB;IACtB,2BAA2B;IAC3B,uBAAuB;IACvB,mCAA2B;IAA3B,2BAA2B;EAC7B;AACF;;AAEA;EACE;IACE,WAAW;EACb;;EAEA;IACE,+BAA+B;EACjC;;EAEA;IACE,2CAA2C;EAC7C;;EAEA;IACE,sBAAsB;EACxB;;EAEA;IACE,WAAW;IACX,uBAAuB;IACvB,gBAAgB;EAClB;;EAEA;IACE,uBAAuB;EACzB;;EAEA;IACE,6BAA6B;IAC7B,2BAA2B;IAC3B,sBAAsB;IACtB,4BAA4B;EAC9B;;EAEA;IACE,+BAA+B;EACjC;;EAEA;IACE,kBAAkB;IAClB,mBAAmB;IACnB,iBAAiB;EACnB;;EAEA;IACE,wBAAwB;EAC1B;;EAEA;IACE,sBAAsB;EACxB;;EAEA;IACE,wBAAwB;EAC1B;;EAEA;;IAEE,0BAA0B;EAC5B;;EAEA;IACE,qBAAqB;EACvB;;EAEA;IACE,sCAAsC;EACxC;;EAEA;IACE,8BAA8B;EAChC;;EAEA;IACE,+BAA+B;EACjC;;EAEA;IACE,sBAAsB;EACxB;;EAEA;IACE,sCAAsC;IACtC,cAAc;EAChB;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;;;IAGE,oCAAoC;EACtC;AACF;;AAGA;EACE;IACE,uBAAuB;EACzB;AACF;;ACzPA;IACI,YAAY;IACZ,iBAAiB;AACrB;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI;QACI,gBAAgB;IACpB;AACJ","sourcesContent":[".containerWith {\n    width: 100%;\n    max-width: 1260px !important;\n    margin: 0 auto;\n}\n\n.container {\n    max-width: 100%;\n}\n\n/* Text - Start */\n.subText {\n    color: var(--secondary-foreground);\n    font-size: 14px;\n}\n\n/* Text - End */\n\n/* Header */\n\n.navigationLink a {\n    padding-right: 20px !important;\n    padding-left: 20px !important;\n    color: var(--primary-foreground) !important;\n    font-size: 18px;\n    border-bottom: 2px solid transparent;\n}\n\n.navigationLink a:hover,\n.navigationLink a:focus,\n.navigationLink a:active {\n    border-bottom: 2px solid var(--primary-foreground);\n}\n\n/* Header */\n\n/* commonCss */\n.noPadding {\n    padding: 0;\n}\n\n.heading {\n    padding: 30px 0px 24px 0px;\n    font-weight: 700;\n    font-size: 24px;\n    color: var(--primary-foreground);\n}\n\n.widthInner {\n    margin: 0px auto 0px auto;\n    border-radius: 4px;\n    padding: 0px;\n    margin: 0px 15px 30px;\n}\n\n.noMargin {\n    margin: 0;\n}\n\n.formControlInputTable {\n    border: none;\n    width: 100px;\n    height: auto;\n}\n\n.backBtn {\n    margin-left: 15px;\n    display: inline-block;\n}\n\n.backBtn:active,\n.backBtn:hover,\n.backBtn:focus {\n    color: var(--primary-bg);\n    text-decoration: none !important;\n}\n\n.textAlignRight {\n    text-align: right;\n}\n\n.displayInlineBlock {\n    display: inline-block;\n}\n\n.displayBlock {\n    display: block;\n}\n\n.countryCode {\n    width: 15%;\n    vertical-align: top;\n}\n\n.vtrMiddle {\n    vertical-align: middle;\n}\n\n/* commonCss */\n\n.editIcon {\n    width: 100%;\n    width: 15px;\n    vertical-align: middle;\n    margin-right: 3px;\n}\n\n.iconBtn,\n.iconBtn:hover,\n.iconBtn:focus {\n    padding: 0 !important;\n    background: transparent !important;\n    color: var(--danger-action-color) !important;\n    border: 0 !important;\n    white-space: nowrap;\n    font-size: 16px !important;\n    text-decoration: unset !important;\n    cursor: pointer;\n}\n\n.profileImg {\n    width: 100%;\n    height: auto;\n    margin-bottom: 18px;\n}\n\n.profileImgSection {\n    width: 100%;\n    margin: 0 auto;\n    padding: 30px;\n    border-radius: 12px;\n    border: 1px solid var(--primary-border);\n    background: var(--primary-input-bg);\n\n}\n\n.profileImgWidth {\n    margin: 0;\n    max-width: 100% !important;\n}\n\n.searchInput {\n    width: 100%;\n    max-width: 320px;\n}\n\n.backgroundImg {\n    padding-top: 42%;\n    background-repeat: no-repeat;\n    background-size: contain;\n    margin-bottom: 18px;\n    border-radius: 4px;\n    background-color: transparent;\n    background-position: center;\n    margin-top: 6px;\n    border: 1px dashed var(--primary-border);\n    border-radius: 12px;\n}\n\n/*******************Export CSV section start ******************/\n.exportDisplay {\n    display: flex;\n    justify-content: space-between;\n    flex-wrap: wrap;\n    align-items: center;\n    margin-bottom: 18px;\n    gap: 18px;\n    grid-gap: 18px;\n}\n\n.exportTextSection {\n    display: flex;\n    align-items: center;\n    gap: 12px;\n    flex-wrap: wrap;\n}\n\n.exportText {\n    display: inline-block;\n    padding-right: 5px;\n}\n\n.exportTextContainer {\n    display: flex;\n    align-items: center;\n    color: var(--primary-link-foreground) !important;\n    text-decoration: unset !important;\n    border-bottom: 1px solid var(--primary-link-foreground);\n}\n\n.vtrTextBottom {\n    vertical-align: text-bottom;\n}\n\n.exportImg {\n    width: 100%;\n    max-width: 14px;\n    height: 14px;\n    object-fit: contain;\n}\n\n/*******************Export CSV section End ******************/\n.noLink,\n.noLink:hover {\n    color: var(--primary-link-foreground) !important;\n    cursor: pointer;\n}\n\n.singleCard {\n    width: 500px;\n    margin: 0 auto;\n}\n\n.defaultIcon {\n    background-size: 50px;\n}\n\n.assignProviderSearchInput {\n    width: 100%;\n    max-width: 324px;\n}\n\n.searchGroupContainer {\n    display: flex;\n    align-items: center;\n    gap: 12px;\n    flex-grow: 1;\n}\n\n@media (max-width: 767px) {\n    .searchGroupContainer {\n        width: 100%;\n    }\n\n}","@media (max-width: 1199px) and (min-width: 1024px) {\n  .widthInner {\n    width: 100%;\n    border-radius: 0;\n    margin: 0 auto;\n  }\n\n  .aboutGrid img {\n    position: relative;\n    top: -25px !important;\n  }\n\n  .responsiveView {\n    width: 100% !important;\n    max-width: 175px !important;\n  }\n\n  .positionFive {\n    top: 28% !important;\n  }\n\n  .positionTwo {\n    top: 28% !important;\n  }\n\n  .responsiveContentOne {\n    top: -50px !important;\n  }\n\n  .positionFour {\n    top: -50px !important;\n  }\n\n  .totalCss {\n    width: 100% !important;\n  }\n\n\n}\n\n@media (max-width: 1024px) {\n  .navbar-expand-lg .navbar-toggler {\n    display: block !important;\n    position: absolute;\n    top: 23px;\n    right: 20px;\n  }\n\n  .profileImgSection {\n    padding: 18px;\n  }\n}\n\n@media (max-width: 1023px) and (min-width: 768px) {\n\n  .navigationLink a {\n    color: var(--primary-foreground) !important;\n  }\n\n  .widthInner {\n    width: 100%;\n    border-radius: 0;\n    margin: 0 auto;\n  }\n\n  .responsiveContentOne {\n    width: 300px !important;\n    position: absolute !important;\n    top: -42px !important;\n    left: -5% !important;\n  }\n\n  .positionTwo {\n    top: 24% !important;\n    left: -5% !important;\n  }\n\n  .positionThree {\n    top: 70% !important;\n    left: -5% !important;\n  }\n\n  .positionFour {\n    top: -42px !important;\n    right: -5% !important;\n  }\n\n  .positionFive {\n    top: 20% !important;\n    right: -5% !important;\n  }\n\n  .positionSix {\n    top: 70% !important;\n    right: -5% !important;\n  }\n\n  .responsiveView {\n    width: 100% !important;\n    max-width: 115px !important;\n  }\n\n  .aboutGrid img {\n    top: -1px !important;\n  }\n\n  .contentOne h1 {\n    font-size: 16px !important;\n  }\n\n  .contentOne p {\n    font-size: 12px !important;\n  }\n\n\n  .totalCss {\n    width: 100% !important;\n  }\n\n  .padding {\n    padding: 0px 0 0 60px !important;\n  }\n\n  .singleCard {\n    width: 100% !important;\n  }\n\n  .navigationLink a:hover,\n  .navigationLink a:focus,\n  .navigationLink a:active {\n    border-bottom: 2px solid transparent;\n  }\n}\n\n@media screen and (max-width: 823px) {\n  .navbar-collapse.show {\n    right: 0% !important;\n    top: 0 !important;\n  }\n\n  .navbar-collapse {\n    position: fixed !important;\n    height: 100vh !important;\n    width: 100% !important;\n    background: #fff !important;\n    right: -100% !important;\n    transition: 0.5s !important;\n  }\n}\n\n@media (max-width: 767px) {\n  .content {\n    float: none;\n  }\n\n  .mr-auto.navbar-nav {\n    padding-bottom: 80px !important;\n  }\n\n  .navigationLink a {\n    color: var(--primary-foreground) !important;\n  }\n\n  .footer {\n    padding: 35px 0 0 15px;\n  }\n\n  .widthInner {\n    width: 100%;\n    margin: 0px auto 0 auto;\n    border-radius: 0;\n  }\n\n  .responsiveNoPadding {\n    padding: 0px !important;\n  }\n\n  .contentOne {\n    position: relative !important;\n    text-align: left !important;\n    width: auto !important;\n    padding: 0px 15px !important;\n  }\n\n  .aboutContainer {\n    padding: 30px 0 30px !important;\n  }\n\n  .noPosition {\n    left: 0 !important;\n    right: 0 !important;\n    top: 0 !important;\n  }\n\n  .mobimleImg {\n    display: none !important;\n  }\n\n  .totalCss {\n    width: 100% !important;\n  }\n\n  .imgWidth {\n    padding: 18px !important;\n  }\n\n  .searchInput,\n  .assignProviderSearchInput {\n    max-width: 100% !important;\n  }\n\n  .exportText {\n    display: inline-block;\n  }\n\n  .gridSystem {\n    grid-template-columns: auto !important;\n  }\n\n  .padding {\n    padding: 52px 0 0 0 !important;\n  }\n\n  .heading {\n    padding: 30px 0 24px !important;\n  }\n\n  .singleCard {\n    width: 100% !important;\n  }\n\n  .displayGrid {\n    grid-template-columns: 100% !important;\n    grid-gap: 12px;\n  }\n\n  .boxInner {\n    padding: 35px 0 !important;\n  }\n\n  .navigationLink a:hover,\n  .navigationLink a:focus,\n  .navigationLink a:active {\n    border-bottom: 2px solid transparent;\n  }\n}\n\n\n@media (max-width: 480px) and (min-width: 320px) {\n  .whiteDropdown select {\n    width: 120px !important;\n  }\n}","@import '../../../components/Common.css';\n@import '../../../components/responsive-common.css';\n\n.floatRight {\n    float: right;\n    margin-left: 11px;\n}\n\n.vtrTextBottom {\n    vertical-align: middle;\n}\n\n@media (max-width:1023px) and (min-width:768px) {\n    .buttonMargin {\n        margin-top: 12px;\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"containerWith": `BookingList-containerWith-Blkdc`,
	"container": `BookingList-container-rhra5`,
	"subText": `BookingList-subText-PtKKB`,
	"navigationLink": `BookingList-navigationLink-fGa5B`,
	"noPadding": `BookingList-noPadding-YWTNG`,
	"heading": `BookingList-heading-vURjB`,
	"widthInner": `BookingList-widthInner-HQelW`,
	"noMargin": `BookingList-noMargin-s9bug`,
	"formControlInputTable": `BookingList-formControlInputTable-M64IM`,
	"backBtn": `BookingList-backBtn-YJB1b`,
	"textAlignRight": `BookingList-textAlignRight-AhEbB`,
	"displayInlineBlock": `BookingList-displayInlineBlock-DqUyj`,
	"displayBlock": `BookingList-displayBlock-SRtva`,
	"countryCode": `BookingList-countryCode-CvUEg`,
	"vtrMiddle": `BookingList-vtrMiddle-DukbH`,
	"editIcon": `BookingList-editIcon-EqdO6`,
	"iconBtn": `BookingList-iconBtn-kZWVS`,
	"profileImg": `BookingList-profileImg-rmMpo`,
	"profileImgSection": `BookingList-profileImgSection-kZduv`,
	"profileImgWidth": `BookingList-profileImgWidth-n9l1z`,
	"searchInput": `BookingList-searchInput-q4ygd`,
	"backgroundImg": `BookingList-backgroundImg-lP5Yq`,
	"exportDisplay": `BookingList-exportDisplay-F89am`,
	"exportTextSection": `BookingList-exportTextSection-dRXS1`,
	"exportText": `BookingList-exportText-hnsA1`,
	"exportTextContainer": `BookingList-exportTextContainer-UiE3f`,
	"vtrTextBottom": `BookingList-vtrTextBottom-ktaQC`,
	"exportImg": `BookingList-exportImg-xwLgF`,
	"noLink": `BookingList-noLink-dqsXJ`,
	"singleCard": `BookingList-singleCard-YuN2a`,
	"defaultIcon": `BookingList-defaultIcon-YMiJ_`,
	"assignProviderSearchInput": `BookingList-assignProviderSearchInput-eKfl_`,
	"searchGroupContainer": `BookingList-searchGroupContainer-XPOBw`,
	"aboutGrid": `BookingList-aboutGrid-wF4VT`,
	"responsiveView": `BookingList-responsiveView-b2bbu`,
	"positionFive": `BookingList-positionFive-ukd_f`,
	"positionTwo": `BookingList-positionTwo-wmOMT`,
	"responsiveContentOne": `BookingList-responsiveContentOne-zeMLC`,
	"positionFour": `BookingList-positionFour-s20s2`,
	"totalCss": `BookingList-totalCss-iUrsa`,
	"navbar-expand-lg": `BookingList-navbar-expand-lg-YLUNh`,
	"navbar-toggler": `BookingList-navbar-toggler-yWTEo`,
	"positionThree": `BookingList-positionThree-jSwOW`,
	"positionSix": `BookingList-positionSix-rJhxH`,
	"contentOne": `BookingList-contentOne-PhREp`,
	"padding": `BookingList-padding-Nm7bs`,
	"navbar-collapse": `BookingList-navbar-collapse-SLBnO`,
	"show": `BookingList-show-GjAFS`,
	"content": `BookingList-content-xvG6P`,
	"mr-auto": `BookingList-mr-auto-j6oEx`,
	"navbar-nav": `BookingList-navbar-nav-Q2nvC`,
	"footer": `BookingList-footer-EnqVT`,
	"responsiveNoPadding": `BookingList-responsiveNoPadding-gJPU3`,
	"aboutContainer": `BookingList-aboutContainer-YPi99`,
	"noPosition": `BookingList-noPosition-QgcX9`,
	"mobimleImg": `BookingList-mobimleImg-UIfc8`,
	"imgWidth": `BookingList-imgWidth-LnTrq`,
	"gridSystem": `BookingList-gridSystem-VyPMb`,
	"displayGrid": `BookingList-displayGrid-slzKZ`,
	"boxInner": `BookingList-boxInner-SI0Pp`,
	"whiteDropdown": `BookingList-whiteDropdown-KBF3B`,
	"floatRight": `BookingList-floatRight-uUUbA`,
	"buttonMargin": `BookingList-buttonMargin-WJYMJ`
};
module.exports = ___CSS_LOADER_EXPORT___;
